import React, { FC } from 'react'
import styled, { keyframes } from 'styled-components'
import FULLSCOPE from '../../assets/FullScope.png'
import AIR_LOGO from '../../assets/AIR_Logo.png'
import SAMSON from '../../assets/Samson.png'
import WLIW from '../../assets/wliwFM.png'
import PODFEST from '../../assets/PODFEST.png'
import LIBSYN from '../../assets/libsynlogo.png'
import ONAIR from '../../assets/On_Air_Logo.png'
import RIVERSIDE from '../../assets/RiversideLogo.svg'
import PODCAST_MOVEMENT from '../../assets/PodcastMovement.webp'
import SOUNDS_PROFITABLE from '../../assets/SoundsProfitable.webp'

/*
 * Lifted out of Affiliates so the logo strip can sit directly under the hero
 * as social proof, while the perks panel stays down in the sponsors section.
 */
export const SPONSORS = [
  { href: 'https://libsyn.com/', src: LIBSYN, alt: 'Libsyn Logo' },
  { href: 'http://www.samsontech.com/', src: SAMSON, alt: 'Samson Logo' },
  { href: 'https://www.descript.com/', src: FULLSCOPE, alt: 'FullScope Logo' },
  { href: 'https://www.onairfest.com/', src: ONAIR, alt: 'On Air Fest Logo' },
  { href: 'https://www.wliw.org/radio/', src: WLIW, alt: 'WLIWFM Logo' },
  {
    href: 'https://podcastmovement.com/',
    src: PODCAST_MOVEMENT,
    alt: 'Podcast Movement Logo',
  },
  { href: 'https://podfestexpo.com', src: PODFEST, alt: 'Podfest Logo' },
  { href: 'https://airmedia.org/', src: AIR_LOGO, alt: 'AIR Logo' },
  {
    href: 'https://creators.riverside.com/Incubator',
    src: RIVERSIDE,
    alt: 'Riverside Logo',
  },
  {
    href: 'https://soundsprofitable.com/',
    src: SOUNDS_PROFITABLE,
    alt: 'Sounds Profitable Logo',
  },
]

const scroll = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`

/* Directly under the hero, so it carries its own band rather than inheriting
   a section's margins. */
const Band = styled.section`
  background: #ffffff;
  border-bottom: 1px solid #eeeeea;
  padding: 0.5rem 0;
`

const Eyebrow = styled.p`
  margin: 0;
  padding-top: 0.75rem;
  text-align: center;
  font-size: var(--fs-label);
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #6f6f6f;
`

const Marquee = styled.div`
  position: relative;
  overflow: hidden;
  padding: 1rem 0 1.25rem;

  /* Fade the strip out at both edges */
  mask-image: linear-gradient(
    to right,
    transparent,
    black 8%,
    black 92%,
    transparent
  );
  -webkit-mask-image: linear-gradient(
    to right,
    transparent,
    black 8%,
    black 92%,
    transparent
  );
`

const Track = styled.div`
  display: flex;
  align-items: center;
  width: max-content;
  animation: ${scroll} 35s linear infinite;

  ${Marquee}:hover & {
    animation-play-state: paused;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
  }
`

const LogoLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 2.5rem;

  img {
    height: 64px;
    width: auto;
    max-width: 240px;
    object-fit: contain;
    transition: transform 0.25s ease;
  }

  &:hover img {
    transform: scale(1.12);
  }

  @media (max-width: 768px) {
    padding: 0 1.25rem;
    img {
      height: 40px;
      max-width: 140px;
    }
  }
`

const SponsorMarquee: FC = () => (
  <Band aria-label="Our sponsors">
    <Eyebrow>Supported by</Eyebrow>
    <Marquee>
      <Track>
        {/* Track is rendered twice so the loop is seamless */}
        {[false, true].map((clone) => (
          <React.Fragment key={clone ? 'clone' : 'primary'}>
            {SPONSORS.map(({ href, src, alt }) => (
              <LogoLink
                key={`${alt}${clone ? '-clone' : ''}`}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-hidden={clone || undefined}
                tabIndex={clone ? -1 : undefined}
              >
                <img src={src} alt={clone ? '' : alt} loading="lazy" />
              </LogoLink>
            ))}
          </React.Fragment>
        ))}
      </Track>
    </Marquee>
  </Band>
)

export default SponsorMarquee
